var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-switch",class:{ on: _vm.on, 'empty-value': _vm.onValue === ' ' && _vm.offValue === ' ' },attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"click":function($event){return _vm.$emit('click', !_vm.on)}}},[_vm._v("\n  "+_vm._s(_vm.on ? _vm.onValue : _vm.offValue)+"\n  "),_c('span',{staticClass:"circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }